import React from "react";
import { Backdrop, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { PropagateLoader } from "react-spinners";

const styles = theme => ({
  root: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    position: "fixed",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  paragraph: {
    fontSize: "1rem",
    fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif',
    fontWeight: 400,
    lineHeight: 1.5,
    color: "mintcream",
    fontStyle: "italic",
    marginTop: "2em"
  }
});

const Loader = ({ loader, classes, message }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: theme => theme.zIndex.Backdrop + 1000 }}
      open={loader}
      className={classes.root}
      invisible={true}
    >
      <PropagateLoader color={"white"} loading={loader} size={15} />
      <Typography className={classes.paragraph}>{message}</Typography>
    </Backdrop>
  );
};

export default withStyles(styles)(Loader);
